module.exports = __webpack_public_path__ + "img/promocoes.bbd4640b.svg";